import React, { Component } from 'react';
import { Modal, Input, Radio, DatePicker, Button, Spin, message } from 'antd';
import FormList from '../../../basicElement/FormList';
import TableC from '../../../basicElement/TableC';
import ExportUtil from '../../../../common/ExportUtil';
import UploadFile from '../../../common/UploadFile';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import { getMatchOption } from '../../../shared/selectFn';
import format from '../../../shared/format';
import moment from 'moment';

const RadioGroup = Radio.Group;
const { MonthPicker } = DatePicker;

class ExportFixedLine extends React.Component {
    constructor(props) {
        super(props);
        this.defaultDate = moment().format('YYYY-MM');
        this.state = {
            visible: false,
            confirmLoading: false,
            date: this.defaultDate,
            fileType: undefined,
        }
    }
    
    show = () => {
        this.isTotal = sessionStorage.invState == 1;
        this.setState({
            visible: true,
            fileType: this.isTotal ? 'JDE_REMITTANCE' : undefined,
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            date: this.defaultDate,
            type: undefined,
        });
    }

    query = () => {
        const { date, fileType } = this.state;
        const { invId } = sessionStorage;
        if (!fileType) {
            message.warning('请选择需要导出的内容');
            return;
        }
        const params = {
            investigationId: invId || 0,
            date,
            fileType,
        };
        this.setState({ confirmLoading: true });
        const options = {
            url: `${API_URL.contract.checkFileFtp}`,
            data: { ...params },
            dataType: 'json',
            doneResult: res => {
                this.submit({ ...params });
                this.setState({ confirmLoading: false });
            },
            errorResult: () => {
                this.setState({ confirmLoading: false });
            },
        };
        $.sendRequest(options);
    }

    submit = params => {
        const url = API_URL.contract.getFileFtp;
        ExportUtil.export(params, null, url);
        this.setState({ visible: false });
    }

    disabledDate = current => {
        return current && current.valueOf() > moment().valueOf();
    }

    handleChange = (value, key) => {
        this.setState({ [key]: value });
    }

    render () {
        const { visible, confirmLoading, date, fileType } = this.state;
        const radioStyle = {
            display: 'block',
            paddingLeft: 10,
            height: 30,
            lineHeight: '30px',
        };
        return (
            <Modal
                title="导出固化数据"
                visible={visible}
                onOk={this.query}
                onCancel={this.hide}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
                confirmLoading={confirmLoading}
            >
                <div className="filter-bar">                  
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">请先选择固化月份</label>
                        <MonthPicker
                            disabledDate={this.disabledDate}
                            onChange={(date, dateString) => this.handleChange(dateString, 'date')}
                            placeholder="选择月份"
                            style={{width: 160}}
                            allowClear={true}
                            value={date ? moment(date) : null}
                        />
                    </div>
                </div>
                {
                    !this.isTotal &&
                    <ul className="preview-list">
                        <li className="preview-item">
                            <div className="item" style={{ width: '35%' }}>
                                <label className="ui-label" style={{marginLeft: -15, paddingLeft: 0, width: 140}}>请选择需要导出的内容</label>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item checkBoxchildren" >
                                <RadioGroup onChange={e => this.handleChange(e.target.value, 'fileType')} value={fileType}>
                                    <Radio value="JDE_REMITTANCE_SINGLE" style={radioStyle}>合同请款记录（单表头）</Radio>
                                    <Radio value="JDE_REMITTANCE_DOUBLE" style={radioStyle}>合同请款记录（双表头）</Radio>
                                </RadioGroup>
                            </div>
                        </li>
                    </ul>
                }
            </Modal>
        );
    }
}

let attachmentType = undefined;

class LookAttachment extends Component {
    state = {
        data: [],
        visible: false,
        loading: false,
    }
    
    show = (record, type) => {
        attachmentType = type;
        this.setState({
            record,
            visible: true
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ data: [],
            visible: false
        });
    }

    loadData = () => {
        const { investigationJdeContractId, contractRemittanceApplicationId } = this.state.record;
        this.setState({ loading: true });
        let options;
        if (attachmentType === 'contract') {
            options = {
                method: 'post',
                url: API_URL.contract.queryJdeCodeEnclosure,
                data: {
                    investigationJdeContractId,
                },
                dataType: 'json',
                doneResult: res => {
                    const data = res.data || [];
                    this.setState({
                        data,
                        loading: false,
                    });
                }
            };
        } else {
            options = {
                method: 'post',
                url: API_URL.common.queryEnclosureFileList,
                data: {
                    uploadType: 'CONTRACT_REQUEST_FUNDS',
                    relateId: contractRemittanceApplicationId
                },
                dataType: 'json',
                doneResult: res => {
                    const data = res.datas || [];
                    data.forEach(i => i.id = i.fileMateId);
                    this.setState({
                        data,
                        loading: false,
                    });
                }
            };
        }
        $.sendRequest(options);
    }

    downLoadFile = (e, id) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId: id }, null, url);
    }

    getColumns = () => [{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 120,
    }, {
        title: '附件名称',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => {
            const { id, name } = record;
            return <a onClick={e => this.downLoadFile(e, id)}>{name}</a>
        }
    }]

    render () {
        const { record = {}, visible, data, loading } = this.state;
        const { remittanceCode, investigationName, investigationJdeContractCode } = record;
        return (
            <Modal
                title={attachmentType === 'contract' ? "合同附件" : "请款附件"}
                visible={visible}
                onCancel={this.hide}
                width="500px"
                footer={<Button key="close" type="primary" onClick={this.hide}>关 闭</Button>}
            >
                <Spin spinning={loading}>
                    {
                        attachmentType === 'contract' &&
                        <div style={{ marginBottom: 16 }}>
                            项目简称：{investigationName || ''}
                            <span className="ant-divider" />
                            JDE项目号：{investigationJdeContractCode}
                        </div>
                    }
                    {
                        attachmentType === 'request' &&
                        <div style={{ marginBottom: 16 }}>
                            请款单号：{remittanceCode || ''}
                        </div>
                    }
                    <TableC
                        data={data}
                        columns={this.getColumns()}
                    />
                </Spin>
            </Modal>
        );
    }
}

class OperationLog extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    loadData = () => {
        const { record: { contractRemittanceApplicationId } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.selectContractRemittanceLog,
            data: { contractRemittanceApplicationId },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    data: res.data,
                    loading: false,
                })
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => ([
        {
            title: '操作时间',
            dataIndex: 'createTime',
            key: 'createTime',
            width: 80,
        }, {
            title: '操作人',
            dataIndex: 'userName',
            key: 'userName',
            width: 110,
        }, {
            title: '操作内容',
            dataIndex: 'typeShow',
            key: 'typeShow',
            width: 120,
        }, {
            title: '操作结果',
            dataIndex: 'optionResult',
            key: 'optionResult',
            width: 120,
        }, {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            width: 150,
        }
    ])

    render() {
        const { visible, loading, data, record: { investigationName, remittanceCode } } = this.state;
        return (
            <Modal
                title="操作日志"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                width={800}
                bodyStyle={{ maxHeight: 700 }}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div style={{ marginBottom: 16 }}>
                        项目简称：{investigationName}
                        <span className="ant-divider" />
                        请款单号：{remittanceCode}
                    </div>
                    <div>
                        <TableC
                            data={data}
                            scrollY={500}
                            loading={loading}
                            columns={this.getColumns()}
                            rowKey="contractRemittanceLogId"
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

class ApplyAdjustment extends Component {
    state = {
        loading: false,
        visible: false,
        fileList: [],
        record: {},
        data: {},
        type: '',
    }

    show = (record, type) => {
        this.setState({
            type,
            record,
            visible: true,
        }, () => {
            type === 'approve' && this.queryRemittanceAdjustmentApply();
        });
    }

    hide = () => {
        this.setState({
            data: {},
            fileList: [],
            visible: false,
        });
    }

    queryRemittanceAdjustmentApply = () => {
        const { record: { contractRemittanceApplicationId } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.queryRemittanceAdjustmentApply,
            data: { contractRemittanceApplicationId },
            dataType: 'json',
            doneResult: res => {
                const { data, data: { files } } = res;
                this.setState({
                    data,
                    fileList: files,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    submit = () => {
        const { type, data, record, fileList } = this.state;
        const {
            contractRemittanceApplicationId,
            remittanceCode,
            investigationJdeContractCode,
            customerCompany,
            investigationName,
            remittanceNum,
            cashReqNode,
            currencyName,
            initialContractAmount,
            remittanceAmount,
        } = record;
        const { comments, approvalStatus, reason, contractRemittanceAdjustmentApplyId } = data;

        let url, params;
        if (type === 'apply') {
            if (!comments) {
                message.warning('请输入合同请款调整原因！');
                return;
            }

            params = {
                contractRemittanceApplicationId,
                remittanceCode,
                investigationJdeContractCode,
                customerCompany,
                investigationName,
                remittanceNum,
                cashReqNode,
                currencyName,
                initialContractAmount,
                remittanceAmount,
                comments,
            };
            fileList.forEach((item, index) => {
                params[`ids[${index}]`] = item.response.fileMetaId;
            });
            url = API_URL.contract.createRemittanceAdjustmentApply;
        } else {
            if (!approvalStatus) {
                message.warning('请选择审批结论！');
                return;
            } else if (approvalStatus === 'REJECT' && !reason) {
                message.warning('请填写拒绝原因！');
                return;
            }

            params = {
                contractRemittanceAdjustmentApplyId,
                approvalStatus,
                reason,
            };
            url = API_URL.contract.approvalRemittanceAdjustmentApply;
        }

        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url,
            data: params,
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    downLoadFile = (e, id) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({fileMetaId: id}, null, url);
    }

    handleInputChange = (e, key) => {
        const { data } = this.state;
        data[key] = e.target.value;
        if (key === 'approvalStatus') {
            data.reason = undefined;
        }
        this.setState({ data });
    }

    handleUploadChange = (file, fileList) => {
        this.setState({ fileList });
    }

    getContent = () => {
        const {
            type,
            data,
            record,
            fileList,
        } = this.state;
        const {
            remittanceCode,
            investigationJdeContractCode,
            customerCompany,
            investigationName,
            remittanceNum,
            cashReqNode,
            currencyName,
            initialContractAmount,
            remittanceAmount,
        } = record;
        const { comments, approvalStatus, reason } = data;

        const uploadParams = {
            uploadType: 'REMITTANCE_ADJUSTMENT_APPLY',
            path: Date.now(),
            relateId: '',
        };
        const asterisk = <span style={{color: 'red'}}>*</span>;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">请款单号:</div>
                    <div className="item-right">
                        {remittanceCode}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">JDE项目号:</div>
                    <div className="item-right">
                        {investigationJdeContractCode}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">客户付款单位:</div>
                    <div className="item-right">
                        {customerCompany}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">项目简称:</div>
                    <div className="item-right">
                        {investigationName}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">请款笔数:</div>
                    <div className="item-right">
                        {remittanceNum}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">请款节点:</div>
                    <div className="item-right">
                        {cashReqNode}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">币种:</div>
                    <div className="item-right">
                        {currencyName}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">合同约定请款金额/原币:</div>
                    <div className="item-right">
                        {format('money', initialContractAmount)} 元
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">合同约定请款金额/人民币(元):</div>
                    <div className="item-right">
                        {format('money', remittanceAmount)} 元
                    </div>
                </li>
                <li className="modal-item">
                <div className="item-left">{type === 'apply' && asterisk}合同请款调整原因:</div>
                    <div className="item-right">
                        {
                            type === 'apply' ?
                                <Input
                                    maxLength="255"
                                    value={comments}
                                    placeholder="请输入"
                                    style={{width: 300}}
                                    onChange={e => this.handleInputChange(e, 'comments')}
                                />
                            :
                                comments
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">合同请款调整凭证:</div>
                    <div className="item-right">
                        {
                            type === 'apply' ?
                                <UploadFile
                                    data={uploadParams}
                                    fileList={fileList}
                                    uploadUrl={API_URL.proContract.uploadJdeCodeEnclosure}
                                    removeUrl={API_URL.proContract.deleteJdeCodeEnclosure}
                                    onChange={this.handleUploadChange}
                                />
                            :
                                fileList.map(i => <a key={i.fileMateId} onClick={e => this.downLoadFile(e, i.fileMateId)}>{i.name}<br/></a>)
                        }
                    </div>
                </li>
                {
                    !(type === 'apply') &&
                    <li className="modal-item" style={{ borderTop: '1px solid #f1f1f1' }}>
                        <div className="item-left">{asterisk}审批结论:</div>
                        <div className="item-right">
                            <RadioGroup onChange={e => this.handleInputChange(e, 'approvalStatus')} value={approvalStatus}>
                                <Radio value='AGREE'>同意</Radio>
                                <Radio value='REJECT'>拒绝</Radio>
                            </RadioGroup>
                        </div>
                    </li>
                }
                {
                    !(type === 'apply') && approvalStatus === 'REJECT' &&
                    <li className="modal-item">
                        <div className="item-left">&nbsp;</div>
                        <div className="item-right">
                            <Input
                                maxLength="255"
                                value={reason}
                                placeholder="请填写拒绝原因"
                                style={{width: 300}}
                                onChange={e => this.handleInputChange(e, 'reason')}
                            />
                        </div>
                    </li>
                }
            </ul>
        );
    }

    render() {
        const { visible, loading, type } = this.state;
        return (
            <Modal
                title={type === 'apply' ? '合同请款调整申请' : '审批调整申请'}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="600px"
            >
                <div className="modal-content" style={{ padding: 0 }}>
                    <Spin spinning={loading}>
                        { this.getContent() }
                    </Spin>
                </div>
            </Modal>
        ); 
    }
}

class ApplyHistory extends Component {
    state = {
        data: [],
        visible: false,
        loading: false,
    }
    
    show = id => {
        this.setState({
            visible: true
        }, () => {
            this.loadData(id);
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    loadData = (contractRemittanceApplicationId) => {
        const { invId } = sessionStorage;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.selectByPrimaryKeyByRemittance,
            data: { contractRemittanceApplicationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    loading: false,
                    data,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const columns = [{
            title: '请款单号',
            dataIndex: 'remittanceCode',
            key: 'remittanceCode',
            fixed: 'left',
            width: 100,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'investigationJdeContractMainCode',
            key: 'investigationJdeContractMainCode',
            fixed: 'left',
            width: 110,
        }, {
            title: 'JDE项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            fixed: 'left',
            width: 120,
        }, {
            title: '客户付款单位',
            dataIndex: 'customerCompany',
            key: 'customerCompany',
            width: 120,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 160,
        }, {
            title: '合同性质',
            dataIndex: 'remittanceContractNature',
            key: 'remittanceContractNature',
            width: 80,
        }, {
            title: '合同总金额/人民币(元)',
            dataIndex: 'jdeContractAmount',
            key: 'jdeContractAmount',
            width: 90,
            render: text => format('money', text),
        }, {
            title: '请款笔数',
            dataIndex: 'remittanceNum',
            key: 'remittanceNum',
            width: 80,
        }, {
            title: '请款节点',
            dataIndex: 'cashReqNode',
            key: 'cashReqNode',
            width: 80,
        }, {
            title: '合同约定请款比例',
            dataIndex: 'cashReqRateShow',
            key: 'cashReqRateShow',
            width: 115,
        }, {
            title: '合同约定请款金额/原币',
            dataIndex: 'initialContractAmount',
            key: 'initialContractAmount',
            width: 90,
            render: text => format('money', text),
        }, {
            title: '合同约定请款金额/人民币(元)',
            dataIndex: 'remittanceAmount',
            key: 'remittanceAmount',
            width: 110,
            render: text => format('money', text),
        }, {
            title: '请款进度',
            dataIndex: 'paymentProgress',
            key: 'paymentProgress',
            width: 120,
        }, {
            title: '请款进度具体描述',
            dataIndex: 'paymentProgressComment',
            key: 'paymentProgressComment',
            width: 140,
        }, {
            title: '预计请款日期',
            dataIndex: 'cashReqNodeDateShow',
            key: 'cashReqNodeDateShow',
            width: 100,
        }, {
            title: 'PM',
            dataIndex: 'pm',
            key: 'pm',
            width: 100,
            render: text => text.replace(/,/g, '\r\n'),
        }, {
            title: '发票备注要求',
            dataIndex: 'invoiceTypeComment',
            key: 'invoiceTypeComment',
            width: 120,
        }, {
            title: '请款联系人信息',
            dataIndex: 'cashReqUserString',
            key: 'cashReqUserString',
            width: 160,
        }, {
            title: '发票邮寄信息',
            dataIndex: 'invoiceMailUserString',
            key: 'invoiceMailUserString',
            width: 160,
        }, {
            title: '例数',
            dataIndex: 'randomAmount',
            key: 'randomAmount',
            width: 80,
        }, {
            title: '访视数',
            dataIndex: 'visitAmount',
            key: 'visitAmount',
            width: 80,
        }, {
            title: 'BD',
            dataIndex: 'bd',
            key: 'bd',
            width: 100,
            render: text => text.replace(',', '\r\n'),
        }, {
            title: '合同开始时间',
            dataIndex: 'contractStartTime',
            key: 'contractStartTime',
            width: 90,
        }, {
            title: '合同结束时间',
            dataIndex: 'contractEndTime',
            key: 'contractEndTime',
            width: 90,
        }, {
            title: '项目编号',
            dataIndex: 'investigationCode',
            key: 'investigationCode',
            width: 120,
        }, {
            title: '医院名称或数量',
            dataIndex: 'hospitalNameAndAmount',
            key: 'hospitalNameAndAmount',
            width: 105,
        }, {
            title: '请款申请系统时间',
            dataIndex: 'createDate',
            key: 'createDate',
            width: 80,
        }, {
            title: '币种',
            dataIndex: 'currencyName',
            key: 'currencyName',
            width: 100,
        }, {
            title: '汇率',
            dataIndex: 'exchangeRate',
            key: 'exchangeRate',
            width: 80,
        }, {
            title: '费用类型',
            dataIndex: 'expenseType',
            key: 'expenseType',
            width: 80,
        }, {
            title: '发票类型',
            dataIndex: 'invoiceType',
            key: 'invoiceType',
            width: 80,
        }, {
            title: '收入归属单位',
            dataIndex: 'belongingToUnit',
            key: 'belongingToUnit',
            width: 100,
        }, {
            title: '合同总金额/原币',
            dataIndex: 'contractInitialContractAmount',
            key: 'contractInitialContractAmount',
            width: 110,
            render: text => format('money', text),
        }, {
            title: '请款记录状态',
            dataIndex: 'statusShow',
            key: 'statusShow',
            width: 90,
        }];
        return columns;
    }

    render () {
        const { data, visible, loading } = this.state;
        return (
            <Modal
                title="请款历史"
                visible={visible}
                onCancel={this.hide}
                width="1000px"
                footer={<Button key="close" type="primary" onClick={this.hide}>关 闭</Button>}
            >
                <div>
                    <TableC
                        data={data}
                        loading={loading}
                        columns={this.getColumns()}
                    />
                </div>
            </Modal>
        );
    }
}

class RegisterMilestoneDate extends Component {
    state = {
        data: {},
        record: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        const { contractRemittanceApplicationId, cashReqNodeDateShow } = record;
        this.setState({
            record,
            visible: true,
            data: {
                contractRemittanceApplicationId,
                mileStoneDate: cashReqNodeDateShow || null,
            },
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = (value, key, type) => {
        const { data } = this.state;
        data[key] = value;
        this.setState({ data });
    }

    getColumns = () => {
        const { data } = this.state;

        // 字段属性配置
        const columns = [{
            name: 'milestone到达日期',
            key: 'mileStoneDate',
            type: 'datePicker',
            typeProperty: {
                style: { width: 160 },
            },
            rules: {
                required: true,
            }
        }];

        // 字段值、显示状态配置
        const traverseColumns = function (columns) {
            columns.forEach(column => {
                const { key } = column;
                const typeProperty = column.typeProperty || (column.typeProperty = {});
                typeProperty.canEdit = true;
                typeProperty.value = data[key];
            });
        }
        traverseColumns(columns);

        return columns;
    }

    confirm = () => {
        const hasWritten = this.formRef.validate();
        if (!hasWritten) return;

        const { systemDate } = this.props;
        const { data, record } = this.state;
        const { mileStoneDate } = data;

        if (moment(mileStoneDate).valueOf() <= moment(systemDate).valueOf()) {
            Modal.confirm({
                iconType: 'question-circle',
                title: "系统已到达此milestone到达日期，确认填写此日期，将直接通知BA请款，是否确认填写？",
                onOk: () => {
                    this.save();
                    this.props.informRequest(record);
                },
            });
        } else {
            this.save();
        }
    }

    save = () => {
        const { data } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.setMileStoneDate,
            data,
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        }
        $.sendRequest(options);
    }

    render() {
        const { loading, visible } = this.state;
        return (
            <Modal
                title="登记milestone到达日期"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="create-modal"
                maskClosable={false}
                width="400px"
                confirmLoading={loading}
            >
                <div style={{ margin: '10px 0' }}>
                    <FormList
                        className="form-list fortyPercentage"
                        columns={this.getColumns()}
                        onChange={this.handleChange}
                        ref={el => this.formRef = el}
                    />
                </div>
            </Modal>
        );
    }
}

class RegisterRequestDate extends Component {
    state = {
        data: {},
        record: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        const { contractRemittanceApplicationId, baConfirmCashReqDate } = record;
        this.mileStoneDate = baConfirmCashReqDate;
        this.setState({
            record,
            visible: true,
            data: {
                contractRemittanceApplicationId,
                baConfirmCashReqDate,
            },
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = (value, key, type) => {
        const { data } = this.state;
        switch  (key) {
            case 'baConfirmCashReqDate':
                if (value !== this.mileStoneDate) {
                    data[key] = value;
                    this.setState({ data });
                    break;
                } else {
                    data.baConfirmCashReqDateReason = undefined;
                }
            case 'baConfirmCashReqDateReason':
                data.baConfirmCashReqDateReasonRemark = undefined;
            default:
                data[key] = value;
                this.setState({ data });
                break;
        }
    }

    getColumns = () => {
        const { dateModifyReason } = this.props;
        const { data } = this.state;
        const { baConfirmCashReqDate, baConfirmCashReqDateReason } = data;
        const dateModifyReasonOption = dateModifyReason.map(i => ({ label: i.typeValue, value: i.typeConfigureId }));
        const showRemark = getMatchOption(dateModifyReason, 'typeConfigureId', baConfirmCashReqDateReason).typeValue === '其他';

        // 字段属性配置
        const columns = [{
            name: '确认可请款日期',
            key: 'baConfirmCashReqDate',
            type: 'datePicker',
            typeProperty: {
                style: { width: 180 },
            },
            rules: {
                required: true,
            }
        }];
        if ((this.mileStoneDate && (this.mileStoneDate !== baConfirmCashReqDate))) {
            columns.push({
                name: '修改原因',
                key: 'baConfirmCashReqDateReason',
                type: 'select',
                typeProperty: {
                    style: { width: 260 },
                    list: dateModifyReasonOption
                },
                rules: {
                    required: true,
                }
            }, {
                name: '其他原因备注',
                key: 'baConfirmCashReqDateReasonRemark',
                type: 'input',
                typeProperty: {
                    style: { width: 260 },
                },
                rules: {
                    required: true,
                    display: showRemark
                }
            });
        }

        // 字段值、显示状态配置
        const traverseColumns = function (columns) {
            columns.forEach(column => {
                const { key } = column;
                const typeProperty = column.typeProperty || (column.typeProperty = {});
                typeProperty.canEdit = true;
                typeProperty.value = data[key];
            });
        }
        traverseColumns(columns);

        return columns;
    }

    confirm = () => {
        const hasWritten = this.formRef.validate();
        if (!hasWritten) return;

        const { data } = this.state;

        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.setBaCashReqDate,
            data,
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        }
        $.sendRequest(options);
    }

    render() {
        const { loading, visible } = this.state;
        return (
            <Modal
                title="登记确认可请款日期"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="create-modal"
                maskClosable={false}
                width="500px"
                confirmLoading={loading}
            >
                <div style={{ margin: '10px 0' }}>
                    <FormList
                        className="form-list thirtyPercentage"
                        columns={this.getColumns()}
                        onChange={this.handleChange}
                        ref={el => this.formRef = el}
                    />
                </div>
            </Modal>
        );
    }
}

export {
    ExportFixedLine,
    LookAttachment,
    OperationLog,
    ApplyAdjustment,
    ApplyHistory,
    RegisterMilestoneDate,
    RegisterRequestDate,
};


// WEBPACK FOOTER //
// ./src/components/contractManagement/requestRecord/components/PreviewModal.js